<template>
  <div>
    <Modal v-model="modalShow" width="400">
      <p slot="header" class="text-center">编辑备注</p>
      <Input type="textarea" v-model="remark" :autosize="{minRows: 2,maxRows: 5}" placeholder="请填写备注" />
      <div slot="footer">
        <Button type="text" class="m-r-5" @click="modalShow = false">取消</Button>
        <Button type="primary"  @click="onConfirm">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { updateRemark } from '@/api/order/order'
export default {
  props: {
    orderId: {
      type: Number,
      required: true
    },
    oldRemark: {
      type: String
    },
    onSuccessFun: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      modalShow: false,
      remark: ''
    }
  },
  methods: {
    showModal () {
      this.remark = this.oldRemark
      this.modalShow = true
    },
    onConfirm () {
      if (this.remark.trim() === '') {
        this.$Notice.error({ desc: '请填写备注信息' })
        return
      }
      const postData = {
        orderId: this.orderId,
        remark: this.remark
      }
      updateRemark(postData).then(res => {
        if (res && res.success) {
          this.$Notice.success({ desc: '操作成功' })
          this.onSuccessFun()
          this.modalShow = false
        }
      })
    }
  }
}
</script>
